(() => {
  angular
    .module('gm.common.vaults')
    .directive('gmyVaultMap', gmyVaultMap);

  function gmyVaultMap() {
    'ngInject';

    const directive = {
      link,
      restrict: 'E',
      require: 'ngModel',
      scope: {
        currency: '=',
        vaults: '=',
        hideVaultDetailsPin: '@'
      },
      replace: true,
      templateUrl: 'modules/vaults/directives/vault-map/vault-map.html',
    };
    return directive;

    function link(scope, _element, _attrs, ctrl) {
      scope.vaultIndex = 0;

      ctrl.$formatters.push((value) => {
        if (value) {
          const index = scope.vaults.findIndex(v => v.id === value.id);
          if (index > -1) {
            scope.vaultIndex = index;
          }
          return index;
        }
        return value;
      });

      scope.$watch('vaultIndex', () => {
        if (scope.vaults && scope.vaults.length > scope.vaultIndex) {
          ctrl.$setViewValue(scope.vaults[scope.vaultIndex]);
        }
        if (scope.vaults && scope.vaults.length > 0 && scope.vaultIndex >= scope.vaults.length) {
          scope.vaultIndex = 0;
        }
      });

      scope.getCurrentVault = () => {
        if (scope.vaults && scope.vaults.length > scope.vaultIndex) {
          return scope.vaults[scope.vaultIndex];
        }
        return {};
      };

      scope.nextVault = () => {
        if (scope.vaultIndex === scope.vaults.length - 1) {
          scope.vaultIndex = 0;
        } else {
          scope.vaultIndex += 1;
        }
      };

      scope.prevVault = () => {
        if (scope.vaultIndex === 0) {
          scope.vaultIndex = scope.vaults.length - 1;
        } else {
          scope.vaultIndex -= 1;
        }
      };
    }
  }
})();
